import { useRef, useState, useEffect, useCallback } from 'react';

var toggleSelection = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};

var useClipboard = function (options) {
    var _a = options || {}, onSuccess = _a.onSuccess, onError = _a.onError, _b = _a.disableClipboardAPI, disableClipboardAPI = _b === void 0 ? false : _b, copiedDuration = _a.copiedDuration;
    var ref = useRef(null);
    var _c = useState(false), isCoppied = _c[0], setIsCoppied = _c[1];
    var _d = useState(""), clipboard = _d[0], setClipbaord = _d[1];
    useEffect(function () {
        if (copiedDuration)
            setTimeout(function () { return setIsCoppied(false); }, copiedDuration);
    }, [isCoppied]);
    var isSupported = function () { return navigator.clipboard !== undefined; };
    var handleError = function (error) {
        if (onError)
            onError(error);
        else
            throw new Error(error);
    };
    var handleSuccess = function (text) {
        if (onSuccess)
            onSuccess(text);
        setIsCoppied(true);
        setClipbaord(text);
    };
    var copyToClipboard = function (text) {
        navigator.clipboard
            .writeText(text)
            .then(function () { return handleSuccess(text); })
            .catch(function (err) {
            handleError(err);
            setIsCoppied(false);
        });
    };
    var clearClipboard = function () {
        if (isSupported()) {
            navigator.clipboard.writeText("");
        }
        else {
            oldCopyToClipboard("copy");
        }
    };
    var oldCopyToClipboard = function (action, element, input, isInput, text) {
        toggleSelection();
        var range = document.createRange();
        var selection = document.getSelection();
        var span = document.createElement("span");
        span.style.whiteSpace = "pre";
        if (text) {
            span.textContent = text;
        }
        else if (element) {
            if (isInput) {
                span.textContent = input.value;
                if (action === "cut") {
                    input.select();
                }
            }
            else {
                span.textContent = element.innerText;
            }
        }
        else {
            handleError("Both the ref & text were undefined");
        }
        span.addEventListener("copy", function (e) {
            e.stopPropagation();
        });
        span.addEventListener("cut", function (e) {
            e.stopPropagation();
            if (isInput)
                input.value = "";
        });
        document.body.appendChild(span);
        range.selectNodeContents(span);
        selection.addRange(range);
        var successful = document.execCommand(typeof action === "object" ? "copy" : action);
        if (!successful) {
            handleError("Copy command was unsuccessful");
            setIsCoppied(false);
        }
        else {
            handleSuccess(span.textContent);
            span.remove();
            if (action === "cut" && isInput)
                input.blur();
        }
    };
    var copy = function (text) {
        return action("copy", typeof text === "object" ? undefined : text);
    };
    var cut = function () { return action("cut"); };
    var action = useCallback(function (operation, text) {
        if (operation === void 0) { operation = "copy"; }
        var element = ref.current;
        var isInput = element &&
            (element.tagName === "INPUT" || element.tagName === "TEXTAREA");
        var input = ref.current;
        if (isSupported() && !disableClipboardAPI) {
            if (text) {
                copyToClipboard(text);
            }
            else if (element) {
                if (isInput) {
                    copyToClipboard(input.value);
                    if (operation === "cut") {
                        input.value = "";
                    }
                }
                else {
                    copyToClipboard(element.innerText);
                }
            }
            else {
                handleError("Both the ref & text were undefined");
            }
        }
        else {
            oldCopyToClipboard(operation, element, input, isInput, text);
        }
    }, [ref, onSuccess, onError, disableClipboardAPI]);
    return {
        ref: ref,
        isCoppied: isCoppied,
        clipboard: clipboard,
        clearClipboard: clearClipboard,
        isSupported: isSupported,
        copy: copy,
        cut: cut,
    };
};

export default useClipboard;
export { useClipboard };
//# sourceMappingURL=index.es.js.map
